import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { RecipientGetMandatoryFieldsRequest, RecipientsApi } from '@shared/api/rest/recipients';
import { ApiUtils } from '@shared/utils';
import { IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const effect = createEffect((params: IQueryParams<RecipientGetMandatoryFieldsRequest>) =>
  RecipientsApi.getMandatoryFields(params.request, params.signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<string[]>([])
  .on(effect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, () => false)
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(effect.done, () => undefined)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $recipientMandatoryFieldsStore = {
  events: {
    get: ApiUtils.wrapperApi(effect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
